export const agreements = state => state.getIn(['agreements', 'entities']);
export const agreementById = (state, id) => agreements(state).get(String(id));
export const agreementsByIds = (state, ids) => ids.map(id => agreementById(state, id));
